const Advisors = [
  // {picture: '../img/team/alvaro-morin.jpg', name: 'Alvaro Morin ', role: 'UX/UI Advisor'},
  {picture: '../img/team/rene-garcia.jpg', name: 'Rene García', role: 'Digital Products & Biz Advisor'},
  {picture: '../img/team/jen-seitz.jpg', name: 'Jen Seitz', role: 'Content Director / Advisor'},
  // {picture: '../img/team/joe-hennig.jpg', name: 'Joe Hennig', role: 'Growth Digital Marketing / Advisor'},
]

export default Advisors
